import React, { useState } from 'react';
import { CNav, CNavItem, CNavLink, CContainer, CRow, CCol, CCard, CCardBody, CTable, CTableBody, CTableHeaderCell, CTableRow, CTableDataCell } from '@coreui/react';
import PatientInfoDisplay from './PatientInfoDisplay';
import SubmitFinalInfo from './SubmitFinalInfo';

const ShowDetailNote = ({ formData, diagnosis, setShowNote }) => {
    const [activeTab, setActiveTab] = useState("note");

    const renderTableRow = (label, value) => (
        <CTableRow>
            <CTableHeaderCell><strong>{label}</strong></CTableHeaderCell>
            <CTableDataCell>{value}</CTableDataCell>
        </CTableRow>
    );

    return (
        <CContainer>
            <CNav variant="pills" className="justify-content-center">
                <CNavItem>
                    <CNavLink active={activeTab === 'note'} onClick={() => { setActiveTab('note'), setShowNote(true) }}>Final Note</CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink active={activeTab === 'personal'} onClick={() => { setActiveTab('personal'), setShowNote(false) }}>Personal Information</CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink active={activeTab === 'contact'} onClick={() => { setActiveTab('contact'), setShowNote(false) }}>Contact Information</CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink active={activeTab === 'other'} onClick={() => { setActiveTab('other'), setShowNote(false) }}>Practice Details</CNavLink>
                </CNavItem>
            </CNav>
            <CRow className="mb-3" >
                <CCol >
                    {activeTab === 'personal' && (
                        <>
                            <CCard
                                className="mb-4"
                                style={{ marginTop: '24px', borderRadius: '12px', padding: '20px', background: 'var(--ui-bg-modal-body, var(--ui-dashboard-surface, #ffffff))', border: '1px solid rgb(113, 113, 113)', color: 'var(--ui-text-primary, #000000)' }}>
                                <CCardBody>
                                    {/* <h4 className="mb-4" style={{ fontWeight: 'bold', color: 'white' }}>Personal Information</h4> */}
                                    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                                        <li style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid rgb(113, 113, 113)', display: 'flex', alignItems: 'center' }}>
                                            <span style={{ minWidth: '120px' }}>First Name:</span>
                                            <span style={{ color: 'var(--ui-text-secondary, #555555)' }}>{formData.FirstName || 'N/A'}</span>
                                        </li>
                                        <li style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid rgb(113, 113, 113)', display: 'flex', alignItems: 'center' }}>
                                            <span style={{ minWidth: '120px' }}>Middle Name:</span>
                                            <span style={{ color: 'var(--ui-text-secondary, #555555)' }}>{formData.MiddleName || 'N/A'}</span>
                                        </li>
                                        <li style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid rgb(113, 113, 113)', display: 'flex', alignItems: 'center' }}>
                                            <span style={{ minWidth: '120px' }}>Last Name:</span>
                                            <span style={{ color: 'var(--ui-text-secondary, #555555)' }}>{formData.LastName || 'N/A'}</span>
                                        </li>
                                        <li style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid rgb(113, 113, 113)', display: 'flex', alignItems: 'center' }}>
                                            <span style={{ minWidth: '120px' }}>Date of Birth:</span>
                                            <span style={{ color: 'var(--ui-text-secondary, #555555)' }}>{new Date(formData.DOB).toLocaleDateString('en-US') || 'N/A'}</span>
                                        </li>
                                        <li style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid rgb(113, 113, 113)', display: 'flex', alignItems: 'center' }}>
                                            <span style={{ minWidth: '120px' }}>Gender:</span>
                                            <span style={{ color: 'var(--ui-text-secondary, #555555)' }}>{formData.Gender || 'N/A'}</span>
                                        </li>
                                        <li style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid rgb(113, 113, 113)', display: 'flex', alignItems: 'center' }}>
                                            <span style={{ minWidth: '120px' }}>Age:</span>
                                            <span style={{ color: 'var(--ui-text-secondary, #555555)' }}>{formData.Age || 'N/A'}</span>
                                        </li>
                                    </ul>

                                </CCardBody>
                            </CCard>
                        </>
                    )}

                    {activeTab === 'contact' && (
                        <CCard
                            className="mb-4"
                            style={{ marginTop: '24px', borderRadius: '12px', padding: '20px', background: 'var(--ui-bg-modal-body, var(--ui-dashboard-surface, #ffffff))', border: '1px solid rgb(113, 113, 113)', color: 'var(--ui-text-primary, #000000)' }}>
                            <CCardBody>
                                {/* <h4 className="mb-4" style={{ fontWeight: 'bold', color: 'white' }}>Contact Information</h4> */}
                                <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                                    <li style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid rgb(113, 113, 113)' }}>
                                        <span>Emergency Contact Name:</span> <span style={{ marginLeft: '10px', color: 'var(--ui-text-secondary, #555555)' }}>{formData.EmergencyName || 'N/A'}</span>
                                    </li>
                                    <li style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid rgb(113, 113, 113)' }}>
                                        <span>Emergency Contact Phone:</span> <span style={{ marginLeft: '10px', color: 'var(--ui-text-secondary, #555555)' }}>{formData.EmergencyPhone || 'N/A'}</span>
                                    </li>
                                </ul>
                            </CCardBody>
                        </CCard>
                    )}



                    {activeTab === 'other' && (
                        <SubmitFinalInfo diagnosis={diagnosis} formData={formData} />

                    )}
                </CCol>
            </CRow>
        </CContainer>
    );
};

export default ShowDetailNote;



